/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Text } from '@blend/enterprise-components';
import { TypeaheadResultComponent } from '../../TypeaheadSearch/TypeaheadResults';
import styled from 'styled-components';
import { Box } from 'grommet';

const StyledLink = styled(Link)`
  display: inline-block;
  padding: 16px 24px;
  width: 100%;
  text-decoration: none;
`;

export namespace PipelineSearchResult {
  export type Props = TypeaheadResultComponent.Props;
}

export const PipelineSearchResult: React.FC<PipelineSearchResult.Props> = ({
  result: { principalId, firstName, lastName, email },
}) => (
  <Box>
    <StyledLink id="it-pipeline-search-link" to={`/notary/${principalId}/dashboard`}>
      <Text displayBlock={true} weight="semibold">
        {firstName} {lastName}
      </Text>
      <Text displayBlock={true} fontSize="sm">
        {email}
      </Text>
    </StyledLink>
  </Box>
);
